const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/components/CIS4mSelect.tsx';
import Imm from 'immutable';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4mValidation } from '../hooks';
import { CIS4mValueComponentProps, OptionEntry } from '../types';
import { MenuItem, TextField, TextFieldProps } from '@mui/material';
import { mapObjectToOption, mapOptionToObject } from '../utils/data';
import { useCIS4mContext } from '../context';
import { TextInput, useOptionalText } from '../../../utils/intlUtils';
import { useIntl } from 'react-intl';

const emptyMap = Imm.Map<any, any>();

interface Props extends CIS4mValueComponentProps {
    label?: TextInput;
    options: OptionEntry[];
    required?: boolean;
    valueAsObject?: boolean;
    fullWidth?: boolean;
}

const sxTextField: TextFieldProps['sx'] = {
    mt: 0.5,
    mb: 0.5,
    mr: 2,
};

const sxMenuItem = {
    whiteSpace: 'normal',
};

export const CIS4mSelect = forwardRef((props: Props, ref: any) => {
    const {
        disabled = false,
        fullWidth,
        hidden = false,
        initialValue,
        options,
        path,
        required = false,
        valueAsObject,
    } = props;
    const label = useOptionalText(props.label);
    const [value, setValue, errorMessage] = useCIS4mValidation(ref, {
        disabled,
        hidden,
        initialValue: valueAsObject ? mapObjectToOption(initialValue || emptyMap, options) : initialValue,
        path,
        required,
    });
    const { variant } = useCIS4mContext().style;

    const { formatMessage } = useIntl();

    const menuItems: any = [];

    // Workaround since, Textfield doesn't provide empty value
    if (!required) {
        menuItems.push(
            <MenuItem key={'EMPTY'} value={''} sx={sxMenuItem}>
                <em>{'Keine'}</em>
            </MenuItem>
        );
    }
    options.forEach(option => {
        const label = typeof option.label === 'string' ? option.label : formatMessage(option.label);
        const value = option.value as string; // super unsafe....
        menuItems.push(
            <MenuItem key={label} value={value} sx={sxMenuItem}>
                {label}
            </MenuItem>
        );
    });

    return hidden ? null : (
        <TextField
            label={label === undefined ? '' : label}
            variant={variant}
            fullWidth={fullWidth}
            select
            size={'small'}
            value={valueAsObject ? mapObjectToOption(value || emptyMap, options) : value || ''}
            onChange={(event: any) => {
                if (valueAsObject) {
                    setValue(mapOptionToObject(event.target.value));
                } else {
                    setValue(event.target.value);
                }
            }}
            color={!!errorMessage ? 'error' : 'primary'}
            required={required}
            disabled={disabled}
            hidden={hidden}
            error={!!errorMessage}
            helperText={errorMessage}
            sx={sxTextField}
        >
            {menuItems}
        </TextField>
    );
});

CIS4mSelect.displayName = 'CIS4mSelect';
